module.exports = __webpack_public_path__ + "arrow-slide-prev@2x.png?c83c69b7c882992b3ecc194bbcc94dbd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-slide-prev@2x.png
// module id = 26
// module chunks = 0